import axios from "axios";
import {
  authHeader,
  handleResult,
  handleException,
} from "../helpers";

export const statisticsService = {
    getRevenue,
    getExpense,
    getProjectTaskUtilization
};
  
function getRevenue(year, month, stacked) {
    const requestOptions = {
        headers: authHeader()
    };

    var path = `statistics/revenue/${year}`;
    if(month) path = `${path}/${month}`
    if(stacked) path = `${path}?stacked=${stacked}`

    return axios.get(path, requestOptions).then(handleResult).catch(handleException);
}

function getExpense(year, stacked) {
    const requestOptions = {
        headers: authHeader()
    };
    
    return axios
    .get(`statistics/expense/${year}`, requestOptions)
    .then(handleResult)
    .catch(handleException);
}

function getProjectTaskUtilization(user, year, month) {
    const requestOptions = {
        headers: authHeader()
    };

    let path = 'statistics/projecttaskutilization';
    if(user) path = `${path}/${user}`;
    if(year) path = `${path}/${year}`;
    if(month) path = `${path}/${month}`; 

    return axios
    .get(path, requestOptions)
    .then(handleResult)
    .catch(handleException);
}


